// extracted by mini-css-extract-plugin
export var accordion = "_dw-0";
export var chevron = "_dw-3";
export var closed = "_dw-2";
export var content = "_dw-4";
export var open = "_dw-1";
export var rotate = "_dw-5";